import {Address} from "../address";
import {CompanyCard} from "./companyCard";

export enum OrganizationField {
    ID = "id",
    NAME = "name",
    COUNTRY = "country",
    LOCKED = "locked",
    LOCKED_REASON = "lockedReason",
    ADMIN_EMAIL = "adminEmail",
    ADMIN_LANGUAGE = "adminLanguage",
    MAIN_DKV_CUSTOMER_NUMBER = "mainDKVCustomerNumber",
    ADDITIONAL_DKV_CUSTOMER_NUMBERS = "additionalDKVCustomerNumbers",
    PRODUCTIVE_STAGE = "productiveStage",
    ALL_STAGES = "allStages",
    COMPANY_CARD = "companyCard",
    LOCKED_AT = "lockedAt",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
    DELETED_AT = "deletedAt",
    COMMENT = "comment",
}

export interface Organization {
    [OrganizationField.ID]: number;
    [OrganizationField.NAME]: string;
    [OrganizationField.COUNTRY]: string;
    [OrganizationField.LOCKED]: boolean;
    [OrganizationField.LOCKED_REASON]: string;
    [OrganizationField.ADMIN_EMAIL]: string;
    [OrganizationField.ADMIN_LANGUAGE]: string;
    [OrganizationField.MAIN_DKV_CUSTOMER_NUMBER]: string;
    [OrganizationField.ADDITIONAL_DKV_CUSTOMER_NUMBERS]?: string;
    [OrganizationField.PRODUCTIVE_STAGE]: string;
    [OrganizationField.ALL_STAGES]?: string;
    [OrganizationField.COMPANY_CARD]: CompanyCard;
    [OrganizationField.LOCKED_AT]?: string | null;
    [OrganizationField.CREATED_AT]?: string;
    [OrganizationField.UPDATED_AT]?: string;
    [OrganizationField.DELETED_AT]?: string;
    [OrganizationField.COMMENT]?: string;
}

export enum DkvCustomerNumberField {
    DKV_CUSTOMER_NUMBER = "dkvCustomerNumber",
    NAME = "name",
    EMAIL = "email",
    T4E_ID = "t4eId",
    ADDRESS = "address",
}
export interface DkvCustomerNumber {
    [DkvCustomerNumberField.DKV_CUSTOMER_NUMBER]: string;
    [DkvCustomerNumberField.NAME]: string;
    [DkvCustomerNumberField.EMAIL]: string;
    [DkvCustomerNumberField.T4E_ID]: string;
    [DkvCustomerNumberField.ADDRESS]: Address;
}
